const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/account/signup.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/account/signup")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface SignupForm {
  full_name: string;
  email: string;
  password: string;
  confirm_password: string;
}